import {useSelector} from 'react-redux';


import cartService from '../../../../services/CartService';

import {cartSelectors} from '../index';


/**
 * @param cartId {string} Cart id to check for emptiness
 * @return {boolean} True if cart is not loaded or empty; false if it contains items
 */
function useIsCartEmpty(cartId) {

    const cart = useSelector(state => cartSelectors.getCart(state, cartId));

    return !cart || cart.totalItems === 0;
}


export default useIsCartEmpty;
